module.exports = __webpack_public_path__ + "src/assets/img/32.1bc09b74.svg";